const defaultPageAttributes = {
  body: [
    "widgetlist",
    {
      only: [
        "SectionContentWidget",
        "HeroSliderWidget",
        "InpageNavigationWidget",
        "PageHeaderWidget",
      ],
    },
  ],
  childOrder: "referencelist",
  title: "string",
  shortTitle: "string",
  disturberText: "html",
  disturberValidFrom: "datetime",
  disturberValidUntil: "datetime",
  disturberLink: "linklist",
  hideInNavigation: ["enum", { values: ["yes", "no"] }],
  validFrom: "date",
  validUntil: "date",
  segmentName: "string",
  description: "string",
  shortDescription: "string",
  showAiChat: "boolean",
};

export default defaultPageAttributes;
